import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const TableRow = ({ onClick, style, className, children }) => {
  const is_onclick = typeof onClick === "function";
  // I put the click on tr b/c I was getting invalid dom nesting
  let td_props = is_onclick ? { onClick: onClick, role: "button", tabIndex: 0 } : {};
  if (style) {
    td_props = { ...td_props, ...{ style: style } };
  }
  return (
    <tr className={classNames("et--flex-table--row", className, { "is-button": is_onclick })} {...td_props}>
      {children}
    </tr>
  );
};

TableRow.propTypes = {
  style: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default TableRow;
